// labs.service.ts

import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, shareReplay, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface Lab {
    is_validated?: boolean;
    id?: number;
    name: string;
    institution?: string;
    priority?: number;
    zip_file_name?: string;
    zip_file_size?: string;
    deleted?: boolean;
    link?: string;
}

// labs.service.ts
@Injectable({
    providedIn: 'root'
})
export class LabsService {
    private urlLabs = environment.apiURL + 'labs';
    private labsSubject = new BehaviorSubject<any[]>(null);

    constructor(private httpService: HttpService) { }

    /** Public observable for labs data */
    get labs$(): Observable<any[]> {
        return this.labsSubject.asObservable();
    }

    getLabs(): Observable<Lab[]> {
        if (this.labsSubject.value) {
            // Already cached, return the cached observable
            return this.labsSubject.asObservable();
        }

        // Otherwise, fetch from backend
        return this.httpService.getRequest(this.urlLabs).pipe(
            tap(response => {
                if (response.success) {
                    const filteredAndSortedLabs = response.labs
                        .filter(lab => lab.institution !== '')
                        .sort((a, b) => a.name.localeCompare(b.name));
                    this.labsSubject.next(filteredAndSortedLabs);
                } else {
                    console.error('Failed to load labs data');
                    this.labsSubject.next(null);
                }
            }),
            map(() => this.labsSubject.value),
            shareReplay(1)
        );
    }

    refreshLabs(): void {
        this.labsSubject.next(null);
        this.getLabs().subscribe();
    }
}


export interface EditingLab extends Lab {
    valid?: boolean;
}

export function labsValidator(control: AbstractControl): ValidationErrors | null {
    const labs = control.value as EditingLab[] | null;
  
    if (!Array.isArray(labs) || labs.length === 0) {
      return { required: true };
    }
  
    const invalidLabs = labs.some(lab => !lab.id && !lab.valid);
    if (invalidLabs) {
      return { invalidLabs: true };
    }
  
    return null;
  }
  